import { SvgIcon } from '@mui/material'

// Types
import { SvgIconProps } from '@mui/material'

const StarIconAtom = (props: SvgIconProps) => {
	return (
		<SvgIcon {...props} viewBox="0 0 51 51">
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth={5}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M32.7038 11.0713L35.7 17.0637C36.1037 17.8925 37.1875 18.6787 38.1013 18.8487L43.52 19.7412C46.9838 20.315 47.7913 22.8225 45.305 25.33L41.0762 29.5587C40.375 30.26 39.9713 31.6412 40.205 32.64L41.4162 37.8675C42.3725 41.99 40.1625 43.605 36.5288 41.4375L31.45 38.42C30.5362 37.8675 29.0063 37.8675 28.0925 38.42L23.0137 41.4375C19.38 43.5837 17.17 41.99 18.1263 37.8675L19.3375 32.64C19.5713 31.6625 19.1675 30.2812 18.4663 29.5587L14.2375 25.33C11.7513 22.8437 12.5588 20.3362 16.0225 19.7412L21.4413 18.8487C22.355 18.7 23.4388 17.8925 23.8425 17.0637L26.8388 11.0713C28.4325 7.82 31.0675 7.82 32.7038 11.0713Z"
			/>

			<g opacity={0.4}>
				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" d="M17 10.625H4.25" />
				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" d="M10.625 40.375H4.25" />
				<path fill="none" stroke="currentColor" strokeWidth={5} strokeLinecap="round" strokeLinejoin="round" d="M6.375 25.5H4.25" />
			</g>
		</SvgIcon>
	)
}

export default StarIconAtom
